<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" isActive="product" />
    <div class="headerbgi"><span>产品中心</span><b>  PRODUCT CENTER</b></div>
    <div class="main-body">
      <span class="cpzx">产品中心</span>
      <div class="line"></div>
      <span class="center-text1"
        >共享、众创、实时、互动、聚合、效率、安全、智能、数据、开放</span
      >
      <span class="center-text2"
        >平台数据化、数据结构化、结构智能化
        不同层次与领域的服务、信息、数据公开化</span
      >
      <div class="cpzc-box">
        <div>
          <div class="boxshadow">
          <span>就业创业服务云平台 </span
          ><b
            >共享、众创、实时、互动、聚合、效率、安全、智能、数据、开放</b
          >
          <div @click="tojycyfyypt" class="btn">查看更多<span>></span></div>
         
          </div>
           <p >就业创业服务云平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>网络创业实训平台</span
          ><b
            >《东云启创互联网创业教学平台》将实践教学与IT技术成功结合，打造了国内领先的系统化、集成化的互联网创业模拟实训系统，有针对性的解决了线上运营过程中的实训难题。整个平台围绕互联网时代特色，符合“专注、极致、口碑、快”的互联网思维，培养创业者具备互联网素质，成为新型综合互联网电商人才。</b
          >
          <div @click="towlcysxpt" class="btn">查看更多<span>></span></div>
         
          </div>
           <p >网络创业实训平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>网络模拟实训平台</span
          ><b
            >创业环境分析、组建高效团队、激发创新思维、把握创业商机、企业开办准备、模拟经营管理、创业质量评估、形成创业 计划</b
          >
          <div @click="towlmnsxpt" class="btn">查看更多<span>></span></div>
          
          </div>
          <p>网络模拟实训平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>就业实训平台</span
          ><b
            >《就业实训系统》软件从就业实际需求出发，共设计了三大模块：职业生涯规划、求职之路和职场人生。 本系统采用第一人称视角，让学员在系统中进行相关就业知识的学习和就业技能的提升， 学员可以通过完成就业实训不同模块的任务，对自身有更精准的定位从而增强其求职能力。</b
          >
          <div @click="tojysxpt" class="btn">查看更多<span>></span></div>
          
          </div>
          <p>就业实训平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>创新就业创业测评平台 </span
          ><b
            >创就业测评云平台采用POTDPQE模型。 为用户提供创业准备综合测评、创业潜质人才素质测评、创业人格行为特征测评、创业人才综合测评； 职业规划测评、职业定位测评、性格气质测评、职业发展测评、职业潜能测评、职业综合素质测评、就业心理测评。 完成职业的规划、定位、发展、潜能等全方位的测评，并对职业的测评数据进行整合与分析，打通职业规划信息与职业发展信息的孤岛。</b
          >
          <div @click="tocxjycycppt" class="btn">查看更多<span>></span></div>
          
          </div>
          <p>创新就业创业测评平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>东云启创慕课平台 </span
          ><b
            >启创云面向全国创就业领域，基于云计算技术，依托PAAS平台，提供数据驱动、智慧驱动两大核心应用，功能覆盖共享服务。</b
          >
          <div @click="todyqcmkpt" class="btn">查看更多<span>></span></div>
         
          </div>
           <p>东云启创慕课平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>物流管理教学平台</span
          ><b
            >《物流教学模拟平台》设置了原材料供应商、厂商、零售商、贸易公司、第三方物流公司五个角色，主要模拟了厂商采购生产流程，厂商和贸易公司、厂商和零售商之间的交易流程。</b
          >
          <div @click="towlgljxpt" class="btn">查看更多<span>></span></div>
          
          </div>
          <p>物流管理教学平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>人力资源管理实训系统 </span
          ><b
            >《人力资源管理实训系统》全面模拟了企业人力资源规划、招聘、配置、培训、绩效考核、薪酬管理和劳动关系7个专员的典型职能和实际工作，体现了现代大型企业的人力资源管理部门的工作职能及组织结构，完整的构建了人力资源管理的知识体系。</b
          >
          <div @click="torlzyglsxxt" class="btn">查看更多<span>></span></div>
          
          </div>
          <p>人力资源管理实训系统</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>市场营销综合实训系统 </span
          ><b
            >《市场营销综合实训系统》集成了四大板块，循序渐进的涵盖市场营销的管理和技能锻炼，形成完整的体系。 主要分为了解自身特点、提升必要能力、实践学习体验和熟悉网络营销四大板块。</b
          >
          <div @click="toscyxzhsxxt" class="btn">查看更多<span>></span></div>
          
          </div>
          <p>市场营销综合实训系统</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>东云启创直播平台 </span
          ><b
            >启创云面向全国创就业领域，基于云计算技术，依托PAAS平台，提供数据驱动、智慧驱动两大核心应用，功能覆盖共享服务。</b
          >
          <div @click="todyqczbpt" class="btn">查看更多<span>></span></div>
         
          </div>
           <p>东云启创直播平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>国家商贸模拟教学平台</span
          ><b
            >《国际商务教学模拟平台》主要模拟国际贸易交易的整个流程，其中包括多种支付（信用证L/C、汇付和托收 ）和多种运输方式（FOB、CIF、CFR、EXWORK ）等的模拟， 给学生提供一个全过程的教学实践模拟平台，为教师提供多种辅助教学手段，提高学生的专业水平和社会实践能力，为将来投入社会工作奠定更好的基础，争取更大的就业机会。</b
          >
          <div @click="togjsmmnjxpt" class="btn">查看更多<span>></span></div>
          
          </div>
          <p>国家商贸模拟教学平台</p>
        </div>

        <div>
          <div class="boxshadow">
          <span>经济学实验教学平台</span
          ><b
            >《经济学实验教学系统》的实验项目根据经济学（包括宏观经济学和微观经济学）的十大重点理论，设计相应的实验，让学员掌握经济学理论知识，并学会运用知识解决现实经济问题。</b
          >
          <div @click="tojjxsyjxpt" class="btn">查看更多<span>></span></div>
          
          </div>
          <p>经济学实验教学平台</p>
        </div>
      </div>

      <div class="ptys">
        <span class="cpzx">平台特色</span>
        <div class="line"></div>
        <div class="ptys-body">
          <div>
            <div class="round">
              <img
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/dainnao.png"
                alt=""
              />
            </div>
            <span>平台数据化</span
            ><b
              >我们是一个专注数据化的团队，我们的每一款产品都致力于打造专业的数据化平台。</b
            >
          </div>
          <div>
            <div class="round">
              <img
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/dainlu.png"
                alt=""
              />
            </div>
            <span>数据结构化</span
            ><b
              >严谨的数据整合，严格遵循行业数据的规范和格式，将最精准的数据展现给用户。</b
            >
          </div>
          <div>
            <div class="round">
              <img
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/fangkuai.png"
                alt=""
              />
            </div>
            <span>结构智能化</span
            ><b
              >完美的数据结构注定智能化的平台，我们每一个平台都嵌入了数据的智能分析，行业数据的智能预测。</b
            >
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// import header from '../components/header.vue'

export default {
  name: 'ProductCenter',
  data () {
    return {
      key: value
    }
  },
  mounted () {
    
  },
  methods: {
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
      // console.log('eeeeeeeee', e.srcElement.scrollTop, e.target.scrollTop)
    },
    towlmnsxpt () {
      this.$router.push('/NetworkSimulation')
    },
    tojycyfyypt() {//就业创业服务云平台
      this.$router.push('/NewsInformation')
    },
    towlcysxpt() {//网络创业实训平台
      this.$router.push('/EntrepreneurshipTraining')
    },
    tojysxpt() {//就业实训平台
      this.$router.push('/EmploymentTraining')
    },
    tocxjycycppt() {//创新就业创业测评云平台
      this.$router.push('/innovationEmploymentAndEntrepreneurshipEvaluation')
    },
    todyqcmkpt(){ //幕客
      this.$router.push('/DongyunQichuangMOOCPlatform')
    },
    towlgljxpt() {//物流管理教学平台
      this.$router.push('/LogisticsManagementPlatform')
    },
    torlzyglsxxt() {//人力资源管理实训系统
      this.$router.push('/ManagementTraining')
    },
    toscyxzhsxxt() {//市场营销综合实训系统
      this.$router.push('/MarketingComprehensiveTrainingSystem')
    },
    todyqczbpt() {//冬运启创直播平台
    this.$router.push('/DongyunQichuangLiveBroadcastPlatform')

    },
    togjsmmnjxpt() {//国家商贸模拟教学平台
      this.$router.push('/InternationalBusinessSimulationTeachingPlatform')
    },
    tojjxsyjxpt() {//经济学实验教学平台
      this.$router.push('/EconomicExperimentTeachingPlatform')
    }




  }

}
</script>

<style lang="scss" scoped>
.ptys {
  margin-bottom: 150px;
  margin-top: 70px;
  height: 700px;
  width: 100%;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/bgblue.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: #ffffff;
  display: flex;
  // justify-content: center;
  align-items: center;
  flex-direction: column;
  .cpzx {
    color: #ffffff !important;
  }
  .ptys-body {
    // margin: ;
    width: 1200px;
    height: 450px;
    // background-color: #f4f4f4;
    display: flex;
    justify-content: space-between;
    div {
      width: 270px;
      height: 100%;
      // background-color: rgb(116, 115, 219);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .round {
        margin-top: 20px;
        width: 120px !important;
        height: 120px;
        background-color: #fff;
        border-radius: 50%;
        margin-bottom: 30px;
        img {
          width: 61px;
        }
      }
      span {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 600;
        margin-bottom: 30px;
      }
      b {
        width: 260px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
    div:nth-child(1) {
      width: 270px;
    }
  }
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.main-body {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .cpzx {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #333333;
    margin-top: 90px;
  }
  .line {
    width: 120px;
    margin-top: 30px;
    height: 4px;
    background: #f4930f;
  }
  .center-text1 {
    margin-top: 47px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .center-text2 {
    margin-top: 16px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-bottom: 55px;
  }
 
  .cpzc-box {
    width: 1200px;
    // height: 933px;
    
    div {
      width: 370px;
      height: 281px;
      float: left;
      overflow: hidden;
      margin-right: 45px;
      // background-color: #f4f4f4;
      margin-bottom: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: relative;
      border-radius: 10px;
      .boxshadow {
      position: absolute;
      left: 0;top: 0;
      width: 100%;
      height: 100%;
      // z-index: -999;
      background-image: none !important;
     
      opacity: 0;
    }
    .boxshadow:hover {
       background-color: #1C43BD !important;
      opacity: .8;
    }
      span {
        position: relative;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #ffffff;
        opacity: 0;
        z-index: 6;
      }
      b {
        position: relative;
        margin-top: 25px;
        width: 310px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        opacity: 0;
        z-index: 9;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      p {
        z-index: 4;
        position: absolute;
        bottom: 10px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        z-index: 9;
      }
      .btn {
        bottom: -48px;
        right: -78px;
        width: 150px;
        height: 50px;
        border: 1px solid #ffffff;
        border-radius: 5px;
        background-image: none !important;
        padding-left: 0px;
        line-height: 50px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        z-index: 99;
        opacity: 0;
        span {
          position: absolute;
          right: 32px;
          top: -2px;
        }
      }
      .btn:hover {
        background: #ffffff;
        color: #1f4bd6;
        span {
          color: #1f4bd6;
        }
      }
    }
    div:hover {
      span {
        transition: 0.5s;
        opacity: 1;
        z-index: 9;
      }
      b {
        transition: 0.5s;
        opacity: 1;
      }
      .btn {
        transition: 0.5s;
        opacity: 1;
      }
      p {
        opacity: 0;
      }
    }
    div:nth-child(3n) {
      margin-right: 0px;
    }
    div:nth-child(1) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img1.png");
      background-size: cover;
      background-repeat: no-repeat;
      // z-index: ;

    }
    div:nth-child(n):hover {
      // background-color: #fff;
      z-index: 999;
    }
    div:nth-child(2) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img2.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(3) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img3.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(4) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/jysxptimg.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(5) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img5.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(6) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img6.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(7) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img7.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(8) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img8.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(9) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/iimg9.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(10) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img10.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(11) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img11.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
    div:nth-child(12) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/img12.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}
.headerbgi {
  width: 100%;
  height: 580px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/产品中心-切图_slices/header.png");
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
   font-size: 40px;
font-family: PingFang SC;
font-weight: 400;
color: #006CDA;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Product-Center.vue